import React, { useEffect, useState } from 'react';
import { Banner, Button, Modal, Checkbox, Typography } from '@riac/design-system';
import { BidDetails } from 'src/components/Bidding/BidDetails';
import { formatCurrency } from 'src/lib/catalog';

export const ConfirmBidModal = ({ onConfirm, auctionTypeId, onReject, item, message, amount }) => {
  const [checkItem, setCheckItem] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [itemNotice, setItemNotice] = useState('');

  const fetchItemCheck = async () => {
    const itemNoticeResults = await (await fetch('/api/timed-auction/check-item', {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ amCode: item.A_MCode }),
    })).json();
    if(itemNoticeResults.success && itemNoticeResults.itemNoticeText) {
      setItemNotice(itemNoticeResults.itemNoticeText);
    }
  };

  useEffect(() => {
    fetchItemCheck().then();
  }, []);

  return (<Modal
    title={'Place Bid'}
    isOpen={true}
    isDismissable
    type='narrow'
    showCloseButton
    onClose={onReject}
    footerButtons={<>
      <Button onPress={() => {
        if(itemNotice.length > 0 && !checkItem) {
          setErrorMessage('Must agree acknowledge the statement by clicking the checkbox');
        } else {
          onConfirm(true);
        }
      }}>
        Place Bid
      </Button>
      <Button variant='secondary' onPress={onReject}>
        Cancel
      </Button>
    </>}
  >
    <div className='flex flex-col gap-5'>
      <Typography color='text-light'>
        {message}
      </Typography>
      <div className='flex flex-row gap-3'>
        <img src={`${CDN_PATH}${item.AuctionID}/255X159/${item.LotNumber}.jpg`} className='h-[60px]'/>
        <div className='flex flex-col gap-1'>
          <div>
            <Typography weight='bold' color='primary' className='text-[12px] leading-[14px]'>Lot {item.LotNumber}</Typography>
            <Typography weight='bold' color='text' className='text-base leading-[22px]'>{item.WebTitle || item.Headline}</Typography>
          </div>
          {auctionTypeId != TIMED_AUCTION_TYPE_ID
            && <Typography color='text-lighter' weight='semibold' size='xs'>
              Estimated Price: {formatCurrency(item.LowEst)} - {formatCurrency(item.HighEst)}
            </Typography>
          }
        </div>
      </div>
    </div>
    <Typography color='text' weight='bold' className='text-base leading-6'>Buyer's Premium: {auctionTypeId != TIMED_AUCTION_TYPE_ID ? '17.5%' : '18.5%'}</Typography>
    <Typography size='xs'>
      All bids in a RIAC on Time are final and can not be changed.
    </Typography>
    <div>
      <Typography color='text-lighter' size='xs'>Please see our <Button variant='text' className='p-0 text-text-lighter' to={`/terms-and-conditions#${auctionTypeId}`} target={'_blank'}>Terms & Conditions</Button> for more information.</Typography>
    </div>
    <div>
      <BidDetails item={item}/>
    </div>
    {itemNotice.length > 0
      && <Checkbox
        isSelected={checkItem}
        onChange={() => setCheckItem(!checkItem)}
        label={itemNotice}
      />
    }
    {errorMessage && <Banner color='error'>
      {errorMessage}
    </Banner>}
  </Modal>);
};
